<template>
  <SimpleCrud
    :save_ok_close="true"
    :headers="headers"
    :name="rq_name"
    :scheme="scheme"
    :flds="flds"
    :beforeSetRows="beforeSetRows"
    :preFilters.sync="pr_fls">
    <template slot="filters">
      <v-row>
        <v-col cols="6">
        <!--   <v-btn color="primary" @click="addItem">
            <v-icon>add</v-icon>
            <span>Agregar Trabajador</span>
          </v-btn> -->
          
          <export-ex name="users" :config_name="`${rq_name}/a/all`">
            Exportar planilla de usuarios
          </export-ex>
        </v-col>
        <v-col cols="2">
          <debounce-select :name="rq_name" :value.sync="filter.s__username" item_key="username" label="KPT MEL" append_icon="search"/>
        </v-col>
        <v-col cols="2">
          <debounce-select :name="rq_name" :value.sync="filter.s__employee_id" item_key="employee_id" label="Nro de SAP" append_icon="search"/>
        </v-col>
        <v-col cols="2">
          <debounce-select :name="rq_name" :value.sync="filter.f__name_similarity" f_key="f__name_similarity" item_key="employee_name" label="Nombre de trabajador" append_icon="search"/>
        </v-col>
      </v-row>
      <v-row>
        <v-col cols="6" offset="6">
          <check-rq
            :ex_filters="pr_fls"
            f_key="is_active"
            :default_value="true"
            :name="`${rq_name}`"
            :value.sync="filter.is_active"
            label="Excluir usuarios deshabilitados"/>
        </v-col>
      </v-row>
    </template>
    <template v-slot:actions="{ item, writeItem, disabled,ask_for_toggle }">
      <fs1 tag="td">
        <div class="actions">
          <v-icon class="ma-1 pointer" @click="writeItem(item)" :disabled="disabled('edit',item)">edit</v-icon>
          <v-icon v-if="item.is_active===true" class="ma-1 pointer" @click="ask_for_toggle(item,'is_active')" :disabled="disabled('delete',item)">delete</v-icon>
          <v-icon v-else class="ma-1 pointer" @click="ask_for_toggle(item,'is_active')" :disabled="disabled('delete',item)">how_to_reg</v-icon>
        </div>
      </fs1>
    </template>
    <template v-slot:employee_name="{ value,item }">
      <fs1 tag="td">
        <span>{{value}}</span>
        <fs1-tooltip text="Usuario deshabilitado" v-if="item.is_active===false">
          <template v-slot:icon_on="{ on }">
            <v-icon class="block_icon_red" v-on="on" >block</v-icon>
          </template>
        </fs1-tooltip>
      </fs1>
    </template>

    <template slot="crud-title">Lista de usuario</template>
    <template slot="write-title" slot-scope="{ selectedItem }">{{selectedItem.id?'Editar':'Agregar'}} usuario</template>
    <template slot-scope="{ selectedItem }" slot="write">
      <div>
        <v-layout wrap>
          <v-flex md6 class="px-4" v-for="(v,k) in flds" :key="k">
            <v-text-field
              v-if="!['profile','role','email'].includes(v.key)"
              :class="scheme[v.key].notNull && !selectedItem[v.key]? 'textEmpty':''"
              :label="v.name"
              :type="scheme[v.key].type === 'int'?'number':'text'"
              :placeholder="v.placeholder"
              clearable prepend-icon="edit" 
              v-model="selectedItem[v.key]"
              dense/>

            <v-select
              v-if="v.key === 'profile'"
              label="Perfiles"
              clearable
              prepend-icon="edit" 
              v-model="selectedItem.profile"
              :items="profiles"
              item-text="name"
              item-value="id"/>

            <!-- <v-select
              v-if="v.key === 'role'"
              label="Roles"
              clearable
              prepend-icon="edit"
              v-model="selectedItem.role"
              :items="filteredRoles(selectedItem)"
              item-text="name"
              multiple
              item-value="id"/> -->
            <v-text-field
              v-if="['email'].includes(v.key)"
              :class="scheme[v.key].notNull && !selectedItem[v.key]? 'textEmpty':''"
              :label="v.name"
              type="text"
              :rules="[rules.email]"
              :placeholder="v.placeholder"
              clearable prepend-icon="edit" 
              v-model="selectedItem[v.key]"
              dense/>
          </v-flex>
        </v-layout>
        <br>
      </div>
    </template>

    <template slot="toggle-title" slot-scope="{ selectedItem }">
      <span>{{selectedItem.is_active===true?'Eliminar':'Restaurar'}} usuario</span>
    </template>
    <template slot-scope="{ selectedItem }" slot="toggle-ask">
      <div>
        ¿{{selectedItem.is_active===true?'Está seguro de eliminar a':'Está seguro que desea restaurar el usuario con nombre '}} {{selectedItem.employee_name}}?
      </div>
    </template>
    <template slot-scope="{ selectedItem,toggle_item,toggle_key }" slot="toggle-btn">
      <v-btn color="primary"  @click="toggle_item(selectedItem,toggle_key,selectedItem.is_active===false && 'patch_restore')" class="ma-4">
        <span>Aceptar</span>
      </v-btn>
    </template>
  </SimpleCrud>
</template>

<script>
import filter from '@/components/mixins/filter';
export default {
  mixins:[filter],
  data() {
    return {
      rq_name:'user',
      pr_fls:{is_active:true},
      scheme:{
        employee_name:{notNull:true, type:'string',label:'Nombre completo'},
        username:{notNull:true, type:'string',label:'KPT MEL'},
        employee_id:{notNull:true, type:'int',label:'Nro de SAP'},
        general_management_name:{notNull:true, type:'string',label:'Gerencia General'},
        management_name:{notNull:true, type:'string',label:'Gerencia'},
        superintendence_name:{notNull:true, type:'string',label:'Superintendencia'},
        position_name:{notNull:true, type:'string',label:'Cargo'},
        profile:{notNull:false, type:'int',label:'Perfil'},
        email:{notNull:true, type:'string',label:'Correo electrónico'},
        /* role:{notNull:false, type:'array',label:'Rol'}, */
      },
      headers:[
				{ text: 'N° Usuario SAP', value: 'employee_id' },
        { text: 'Nombre', value: 'employee_name' },
        { text: 'Gerencia', value: 'management_name' },
				{ text: 'Cargo', value: 'position_name' },
				{ text: 'Email', value: 'email' },
				{ text: 'Perfil', value: 'profile_name' },
				/* { text: 'Roles', value: 'role_names' }, */
        { text: '', value: 'actions' },
        
      ],
      rules: {
        email: value => {
          const pattern = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
          return value ? (pattern.test(value) || 'Formato e-mail invalido.'):true
        }
      },
      flds: [
        {name:'Nombre completo',placeholder:'Ingrese nombre completo',key:'employee_name'},
        {name:'KPT MEL',placeholder:'Ingrese KPT MEL',key:'username'},
        {name:'Nro de SAP',placeholder:'Coloque número de SAP',key:'employee_id'},
        {name:'Gerencia General',placeholder:'Indique la Gerencia General',key:'general_management_name'},
        {name:'Gerencia',placeholder:'Indique la Gerencia',key:'management_name'},
        {name:'Superintendencia',placeholder:'Indique la Superintendencia',key:'superintendence_name'},
        {name:'Cargo',placeholder:'Coloque el cargo usado actualmente',key:'position_name'},
        {name:'Perfil',placeholder:'Coloque perfil del usuario',key:'profile'},
        {name:'Correo electrónico',placeholder:'Ingrese correo electrónico',key:'email'},
        /* {name:'Rol',placeholder:'Ingrese rol',key:'role'}, */
      ],
      user_with_roles:[],
    };
  },
  computed: {
    profiles() {return this.$store.getters.profiles},
  },
  beforeMount(){
    this.filter.is_active = true;
  },
  created(){
    this.requests.gets['role/a/all']()
      .then(r => ((r || {}).results || r) || [])
      .then(r => this.dev_log({r},'roles') ||( this.roles = r));
    this.requests.getsSimple['user_with_roles/a/all']()
      .then(r => this.dev_log({r},'user roles') ||( this.user_with_roles = r));
  },
  methods: {
    filteredRoles(selectedItem) {
      // "Líder de Asset Integrity"(id = 1) solo puede haber 1
      // solo 1 especialista de riesgo
      
      const findToExlude = [1,/* 2, */3];
      const exclude = [];
      findToExlude.forEach(fte => {
        if (this.user_with_roles.find(u => u.id != selectedItem.id && u.role.includes(fte))) exclude.push(fte);
      });
      
      if (exclude.length && !exclude.find(e => e === selectedItem.id)) {
        return this.roles.filter(r => !exclude.includes(r.id))
      }
      return this.roles;
    },
    saveError(e){
      console.error({e});
      this.errors = e;
      this.dialogError = true;
    },
    keys(obj){ return Object.keys(obj) },
    beforeSetRows(){}
  }, // methods
};
</script>
<style scoped>
.block_icon_red{
  color: red;
  font-size:inherit;
  background-color: #fee2e2;
  border-radius: 4px;
  padding:1px;
}
</style>